<template>
  <div id="leftnav-box">
    <div class="leftnav-top">
      <img src="../assets/images/logo.png" alt="" />
    </div>
    <el-menu
      @open="handleOpen"
      @close="handleClose"
      class="el-menu-vertical-demo"
      background-color="#34495E"
      active-text-color="#FFFFFF"
      :default-active="activePath"
      text-color="#fff"
      unique-opened
      :collapse="isCollapse"
    >
      <el-submenu
        :index="item.id + ''"
        v-for="(item, index) in hasChildren"
        :key="item.name"
      >
        <template slot="title">
          <div
            v-if="
              item.label !== '干线物流管理' && item.label !== '支线物流管理'
            "
          >
            <span :class="`mui-icon iconfont ${item.icon}`"></span>
            <span style="margin-left: 13px">{{ item.label }}</span>
          </div>

          <!-- 干线城市退回 -->
          <div style="display: flex" v-if="item.label == '干线物流管理'">
            <span :class="`mui-icon iconfont ${item.icon}`"></span>
            <span style="margin-left: 13px; margin-right: 13px">{{
              item.label
            }}</span>
            <span v-show="trunkshow" :title="trunkCityback" class="num">{{
              trunkCityback
            }}</span>
          </div>
          <!-- 支线城市退回 -->
          <div style="display: flex" v-if="item.label == '支线物流管理'">
            <span :class="`mui-icon iconfont ${item.icon}`"></span>
            <span style="margin-left: 13px; margin-right: 13px">{{
              item.label
            }}</span>
            <span v-show="trunkshow1" :title="branchCitybacknum" class="num">{{
              branchCitybacknum
            }}</span>
          </div>
        </template>
        <el-menu-item-group>
          <el-menu-item
            :index="subItem.name"
            v-for="(subItem, subIndex) in item.children"
            :key="subItem.name"
            @click="clickMenu(subItem)"
          >
            <span
              style="margin-left: 5px"
              v-if="
                subItem.name !== 'trunkCityback' &&
                subItem.name !== 'branchCityback'
              "
              >{{ subItem.label }}</span
            >
            <!-- 干线城市退回 -->
            <div class="Cityback" v-if="subItem.name == 'trunkCityback'">
              <span style="margin-left: 5px; margin-right: 2px">{{ subItem.label }}</span>
              <span
               
                v-show="trunkshow3"
                :title="trunkCityback"
                class="num"
                >{{ trunkCityback }}</span
              >
            </div>
            <!-- 支线城市退回 -->
            <div class="Cityback" v-if="subItem.name == 'branchCityback'">
              <span style="margin-left: 5px; margin-right: 2px">{{ subItem.label }}</span>
              <span
               
                v-show="trunkshow2"
                :title="branchCitybacknum"
                class="num"
                >{{ branchCitybacknum }}</span
              >
            </div>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  inject: ["reload"],
  data() {
    return {
      isCollapse: false,
      oneLevel: [],
      twoLevel: [],
      level: [],
      clickUrl: "",
      activePath: "",
      trunkCityback: "",
      branchCitybacknum: "",
      trunkshow: true,
      trunkshow1: true,
      trunkshow2: true,
      trunkshow3: true,
    };
  },
  created() {
    this.closeMenu();
    this.getAuths();
  },
  mounted() {
    this.getpageList();
  },
  methods: {
    ...mapMutations({
      close: "closeTab",
    }),

    closeMenu() {
      for (let tagssKey in this.tagss) {
        if (tagssKey !== "0") {
          this.close(tagssKey);
        }
      }
      if (this.tagss.length > 1) {
        for (let i = 0; i < this.tagss.length; i++) {
          this.close(i + "");
        }
      }
    },
    getAuths() {
      this.axios({
        method: "post",
        url: "/les/system/auth/getAuths",
      }).then((res) => {
        this.level = res.data;
        console.log(this.level, "列表");
        for (let i = 0; i < this.level.length; i++) {
          var item = this.level[i];
          if (item.pid === "0") {
            this.oneLevel.push({
              label: item.authName,
              id: item.id,
              icon: item.authIcon,
              children: [],
            });
          }
        }
        this.oneLevel.forEach((item, index) => {
          this.level.forEach((itemm, indexx) => {
            if (item.id === itemm.pid) {
              this.oneLevel[index].children.push({
                path: itemm.authPath,
                name: itemm.pathName,
                label: itemm.authName,
              });
            }
          });
        });
        // 给他新增工程发货单字段
        // this.oneLevel.forEach((item)=>{
        //   if (item.label === "干线物流管理") {
        //     this.oneLevel[1].children.push({
        //       label: '预计揽收',
        //       name:"dutiable",
        //       path:'/dutiable',
        //     });
        //     console.log(":::::::",this.oneLevel[1])
        //   }
        // })
      });
    },
    clickMenu(item) {
      this.$router.push({
        name: item.name,
      });
      this.$store.commit("selectMenu", item);
    },
    // 干线城市退货数量
    getpageList() {
      this.axios({
        method: "post",
        url: "/les/logistics/stock/citySendBack",
        params: {
          waybillType: 1, //标识
        },
      }).then((res) => {
        this.trunkCityback = res.data.total;
        console.log(res);

        if (this.trunkCityback == 0) {
          this.trunkshow = false;
          this.trunkshow3 = false;
        }
      });
      this.axios({
        method: "post",
        url: "/les/logistics/stock/citySendBack",
        params: {
          waybillType: 2, //标识
        },
      }).then((res) => {
        // console.log(res, "支线表格数据");
        this.branchCitybacknum = res.data.total;
        if (this.branchCitybacknum == 0) {
          this.trunkshow1 = false;
          this.trunkshow2 = false;
        }
      });
    },
    // 点击列表展开触发时间
    handleOpen(key) {
      console.log("id", key);
      if (key == "1324333364366741506") {
        if (this.branchCitybacknum == 0) {
          this.trunkshow1 = false;
          this.trunkshow = false;
        } else {
          this.trunkshow = false;
          this.trunkshow1 = true;
        }
      }
      if (key == "1324333469043986434") {
        //点击支线物流管理
        if (this.trunkCityback == 0) {
          this.trunkshow = false;
          this.trunkshow1 = false;
        } else {
          this.trunkshow1 = false;
          this.trunkshow = true;
        }
      }
      if (key !== "1324333469043986434" && key !== "1324333364366741506") {
        if (this.trunkCityback !== 0) {
          if (this.trunkshow == false) {
            this.trunkshow = true;
          }
        } else {
          this.trunkshow = false;
        }
        if (this.branchCitybacknum !== 0) {
          if (this.trunkshow1 == false) {
            this.trunkshow1 = true;
          }
        } else {
          this.trunkshow1 = false;
        }
      }
    },
    // 点击列表收起触发时间
    handleClose(key) {
      if (key == "1324333364366741506") {
        if (this.trunkCityback == 0) {
          this.trunkshow = false;
        } else {
          this.trunkshow = true;
        }
      } else if (key == "1324333469043986434") {
        if (this.branchCitybacknum == 0) {
          this.trunkshow1 = false;
        } else {
          this.trunkshow1 = true;
        }
      }
    },
  },
  computed: {
    noChildren() {
      return this.oneLevel.filter((item) => !item.children);
    },
    hasChildren() {
      return this.oneLevel.filter((item) => item.children);
    },
    ...mapState({
      tagss: (state) => state.tab.tabList,
      currentMenu: (state) => state.tab.currentMenu.name,
    }),
  },
  watch: {
    currentMenu(val) {
      // 如果点击干线城市退回和直线城市退回页面直接刷新
      if (val === "trunkCityback") {
        //  this.reload();
        let flag = JSON.parse(localStorage.getItem("isReloadData"));
        if (flag) {
          this.trunkCityback = JSON.parse(localStorage.getItem("isDataList"));
        } else {
          this.getpageList();
        }
        localStorage.setItem("isReloadData", JSON.stringify("isReloadData"));
      } else if (val === "branchCityback") {
        let flag = JSON.parse(localStorage.getItem("isReloadData1"));
        if (flag) {
          this.branchCitybacknum = JSON.parse(
            localStorage.getItem("isDataList1")
          );
        } else {
          this.getpageList();
        }
        localStorage.setItem("isReloadData1", JSON.stringify("isReloadData1"));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.num {
  font-size: 12px;
  border-radius: 50%;
  background: red;
  height: 25px !important;
  line-height: 25px;
  width: 25px !important;
  text-align: center;
  align-self: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.Cityback {
  display: flex;
}
#leftnav-box {
  width: 100%;
  height: 100%;
}
.leftnav-top {
  width: 225px;
  height: 60px;
  line-height: 60px;
}
.leftnav-top > img {
  width: 225px;
  height: 60px;
}
.el-menu {
  width: 225px !important;
  border: none;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 225px !important;
}
.el-menu-item,
.el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
}
.el-submenu__title {
  font-size: 13px !important;
}
.el-menu-item {
  font-size: 13px !important;
  padding-left: 60px !important;
}
.el-menu-vertical-demo ::v-deep .el-menu-item-group__title {
  padding: 0 !important;
}
.is-active {
  background-color: rgb(43 57 70) !important;
}
</style>
